import { useState, useEffect, useCallback } from 'react';
import { IBaseSong } from 'services/api/entities';
import useAudio from './useAudio';

const usePlayer = (song: IBaseSong) => {
  const { audioElement, setSrc, play, pause } = useAudio();

  const [isPlaying, setIsPlaying] = useState(false);

  const onPlayHandler = useCallback(() => {
    setIsPlaying(true);
  }, [setIsPlaying]);

  const onPauseHandler = useCallback(() => {
    setIsPlaying(false);
  }, [setIsPlaying]);

  useEffect(() => {
    const { musicFilePath } = song;
    setSrc(musicFilePath);
  }, [setSrc, song]);

  useEffect(() => {
    if (!audioElement) {
      return;
    }

    audioElement.addEventListener('play', onPlayHandler);
    audioElement.addEventListener('pause', onPauseHandler);

    return () => {
      audioElement.removeEventListener('play', onPlayHandler);
      audioElement.removeEventListener('pause', onPauseHandler);
    };
  }, [audioElement, onPlayHandler, onPauseHandler]);

  return {
    isPlaying,
    play,
    pause,
  };
};

export default usePlayer;
